import { watch, onMounted } from 'vue';
// Default title suffix
const defaultSuffix = ' | پلّه - پلتفرم هوشمند مدیریت کسب و کار';
// Current page title
let currentTitle = 'تجزیه و تحلیل';
// Update document title
const updateTitle = (title) => {
    if (typeof document !== 'undefined') {
        document.title = title + defaultSuffix;
        currentTitle = title;
    }
};
// Set page title
export function usePageTitle(title) {
    if (typeof title === 'string') {
        // If title is provided, set it immediately
        updateTitle(title);
        // Watch for changes if it's a ref
        if (typeof window !== 'undefined') {
            onMounted(() => {
                updateTitle(title);
            });
        }
    }
    else if (title && typeof title.value === 'string') {
        // If it's a ref, watch for changes
        watch(title, (newTitle) => {
            updateTitle(newTitle);
        }, { immediate: true });
    }
    return {
        setTitle: updateTitle,
        currentTitle: () => currentTitle
    };
}
// Set title directly (for use outside components)
export function setPageTitle(title) {
    updateTitle(title);
}
